import { render } from "./CtaSection.vue?vue&type=template&id=6db904b2&scoped=true"
import script from "./CtaSection.vue?vue&type=script&lang=js"
export * from "./CtaSection.vue?vue&type=script&lang=js"

import "./CtaSection.vue?vue&type=style&index=0&id=6db904b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db904b2"]])

export default __exports__